import React, { useEffect, useState } from "react";
import { useSounds } from "../sound";
import { announceMedals } from "../medalEvents";

// « Get Gnomed » : une chance sur 8192, tirée à intervalles pendant que le
// compte est connecté, qu'un gnome passe en bas à droite de l'écran. Il ne
// bloque rien — pas d'overlay, pas de focus volé — juste une image qui glisse
// et repart ; la médaille est acquise dès qu'il apparaît, la visite a eu lieu.
//
// Monté une fois à la racine (voir index.js), à côté du bandeau des médailles :
// il lit le compte directement dans localStorage plutôt que par prop, pour ne
// pas dépendre de la branche d'écran que App.js rend à cet instant.
const CHANCE = 1 / 8192;
const CHECK_EVERY_MS = 20000;
const VISIT_MS = 6000;

const API = process.env.REACT_APP_API_URL || "";

function currentToken() {
  try { return JSON.parse(localStorage.getItem("popuquiz_account"))?.token || null; }
  catch (_) { return null; }
}

export default function GnomeVisit() {
  const [visible, setVisible] = useState(false);
  const { playPop } = useSounds();

  useEffect(() => {
    const id = setInterval(() => {
      const token = currentToken();
      if (!token || Math.random() >= CHANCE) return;
      setVisible(true);
      playPop();
      fetch(`${API}/auth/me/secret`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({ id: "gnome" }),
      }).then(r => r.json()).then(d => announceMedals(d.medals)).catch(() => {});
    }, CHECK_EVERY_MS);
    return () => clearInterval(id);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!visible) return undefined;
    const id = setTimeout(() => setVisible(false), VISIT_MS);
    return () => clearTimeout(id);
  }, [visible]);

  if (!visible) return null;
  return (
    <img src="/sprite/gnome-visit.png" alt="" class="gnome-visit" aria-hidden="true"
      onClick={() => setVisible(false)} />
  );
}
